/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SddMandate } from './SddMandate';
import {
    SddMandateFromJSON,
    SddMandateFromJSONTyped,
    SddMandateToJSON,
} from './SddMandate';

/**
 * 
 * @export
 * @interface UnregisterSddMandateOutput
 */
export interface UnregisterSddMandateOutput {
    /**
     * 
     * @type {SddMandate}
     * @memberof UnregisterSddMandateOutput
     */
    sDDMandate?: SddMandate;
    /**
     * 
     * @type {Error}
     * @memberof UnregisterSddMandateOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the UnregisterSddMandateOutput interface.
 */
export function instanceOfUnregisterSddMandateOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UnregisterSddMandateOutputFromJSON(json: any): UnregisterSddMandateOutput {
    return UnregisterSddMandateOutputFromJSONTyped(json, false);
}

export function UnregisterSddMandateOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnregisterSddMandateOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sDDMandate': !exists(json, 'SDDMandate') ? undefined : SddMandateFromJSON(json['SDDMandate']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function UnregisterSddMandateOutputToJSON(value?: UnregisterSddMandateOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'SDDMandate': SddMandateToJSON(value.sDDMandate),
        'error': value.error,
    };
}

